import type { FC, PropsWithChildren } from "react";
import React from "react";
import styles from "./EngineSkeleton.module.scss";

const EngineSkeleton: FC<PropsWithChildren<{ loading: boolean }>> = (props): JSX.Element => {
    const { loading, children } = props;

    return loading ? (
        <div className={styles.card}>
            <div style={{ display: "flex", gap: "12px" }}>
                <div className={styles.loadbar} style={{ width: "15px", height: "10px" }} />
                <div className={styles.loadbar} style={{ width: "45px", height: "10px" }} />
            </div>
            <div className={styles.loadbar} style={{ width: "315px", height: "15px" }} />
            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                <div className={styles.loadbar} style={{ width: "315px", height: "10px" }} />
                <div className={styles.loadbar} style={{ width: "200px", height: "10px" }} />
                <div className={styles.loadbar} style={{ width: "280px", height: "10px" }} />
            </div>
            <div className={styles.bottom}>
                <div className={styles.loadbar} style={{ width: "83px", height: "10px" }} />
                <div className={styles.loadbar} style={{ width: "103px", height: "10px" }} />
                <div className={styles.loadbar} style={{ width: "83px", height: "10px" }} />
                <div className={styles.loadbar} style={{ width: "83px", height: "10px" }} />
            </div>
            <div className={styles.loadbar} style={{ width: "75px", height: "15px" }} />
            <div className={styles.loadbar} style={{ width: "35px", height: "15px" }} />
        </div>
    ) : (
        <>{children}</>
    );
};

export default EngineSkeleton;
